/* Pizeta — Scroll-to-top button */
(function () {
  var btn = document.querySelector('.pz-scroll-top');
  if (!btn) return;
  var threshold = 600;
  var nearFooterGap = 200;
  var ticking = false;
  function update () {
    var y = window.scrollY || window.pageYOffset;
    var vh = window.innerHeight;
    var doc = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    var nearFooter = (y + vh) >= (doc - nearFooterGap);
    btn.classList.toggle('is-visible', y > threshold);
    btn.classList.toggle('near-footer', nearFooter);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  update();
})();
